module.exports = __webpack_public_path__ + "static/Femi_Shonubi-77ef98fcc257c462aa14d1e7a56e67f0.png";